
























import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconHousePurchase extends Vue {
    @Prop({ type: Number, default: 32 }) readonly size!: number
}
